module.exports = __webpack_public_path__ + "static/media/7-mobile.66e4d5c9.jpg";